import { CartAddEvent } from '@theme/events';

class CalendarOffer extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    this.status = this.querySelector('[role="status"]');
    const options = { signal: this.controller.signal };
    this.form.addEventListener('change', (event) => {
      if (event.target.matches('[data-slot="single"]')) {
        const primary = this.querySelector('[data-slot="primary"]');
        primary.value = event.target.value;
      }
      this.update();
    }, options);
    this.closest('.shopify-section')?.addEventListener('change', (event) => {
      const picker = event.target.closest('variant-picker');
      if (!picker || picker.dataset.productId !== this.dataset.productId) return;
      const option = event.target.selectedOptions?.[0] || event.target;
      this.syncStyle(option.dataset.variantId, option.value);
    }, options);
    const selected = this.querySelector('[data-slot="single"]')?.selectedOptions[0];
    if (selected) this.syncStyle(selected.value, selected.textContent.trim());
    this.form.addEventListener('click', (event) => {
      const heading = event.target.closest('.calendar-offer__heading');
      if (!heading || event.target.matches('input')) return;
      event.preventDefault();
      const radio = heading.querySelector('input[type="radio"]');
      if (!radio.disabled) {
        radio.checked = true;
        this.update();
      }
    }, options);
    this.form.addEventListener('submit', (event) => this.submit(event), options);
    this.querySelector('input[value="pair"]').disabled = false;
    this.update();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  syncStyle(variantId, title) {
    const single = this.querySelector('[data-slot="single"]');
    const selected = [...single.options].find((option) => option.value === String(variantId));
    const style = selected?.textContent.trim() || title;
    for (const select of this.querySelectorAll('select[data-slot]')) {
      const match = [...select.options].find((option) => option.textContent.trim() === style);
      if (match) select.value = match.value;
    }
    this.update();
  }

  selections() {
    const pair = this.form.elements.calendar_offer.value === 'pair';
    return (pair ? ['primary', 'partner'] : ['single']).map((slot) => this.querySelector(`[data-slot="${slot}"]`));
  }

  update() {
    const pair = this.form.elements.calendar_offer.value === 'pair';
    const available = (!pair || this.dataset.pairReady === 'true') && this.selections().every((select) => select?.selectedOptions[0]?.dataset.available === 'true');
    this.button.disabled = this.busy || !available;
    this.button.textContent = this.busy ? this.status.dataset.adding : available ? this.status.dataset.add : this.status.dataset.soldOut;
    if (!this.busy) this.status.textContent = '';
  }

  async submit(event) {
    event.preventDefault();
    if (this.busy || this.button.disabled || !this.form.reportValidity()) return;
    const quantity = Number(this.form.elements.quantity.value);
    if (!Number.isSafeInteger(quantity) || quantity < 1) return;
    const items = this.selections().map((select) => ({ id: Number(select.value), quantity }));
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId))].slice(0, 5);
    this.busy = true;
    this.update();
    let message = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || this.status.dataset.error);
      message = this.status.dataset.added;
      if (document.querySelector('cart-drawer-component')) {
        this.dispatchEvent(new CartAddEvent({}, String(items[0].id), {
          source: 'product-form-component',
          productId: this.dataset.productId,
          itemCount: quantity * items.length,
          sections: result.sections,
        }));
      } else {
        window.location.assign(this.dataset.cartUrl);
      }
    } catch (error) {
      message = error.message || this.status.dataset.error;
    } finally {
      this.busy = false;
      this.update();
      this.status.textContent = message;
    }
  }
}

if (!customElements.get('calendar-offer')) customElements.define('calendar-offer', CalendarOffer);
